/**
 * Registro do service worker (PWA Hydrodata).
 *
 * Estratégia conservadora:
 * - Só registra em produção (window.location.hostname !== 'localhost')
 *   pra evitar cache atrapalhando o dev loop.
 * - Aguarda window.load pra não competir com o first paint.
 * - Quando o SW detecta nova versão (installing → installed mas controller
 *   já existe), notifica via console + dispara evento `sw-update-ready`
 *   que pode ser ouvido pra exibir banner "Nova versão disponível".
 */

export function registerSW(): void {
  if (!('serviceWorker' in navigator)) return;

  const isLocalhost = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '[::1]'
  );
  // Em dev (localhost) NÃO registra — SW cacheia tudo e quebra hot reload.
  if (isLocalhost) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => {
        // Nova versão sendo instalada
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              // Já tinha um SW antes → essa instalação é uma atualização
              console.info('[PWA] Nova versão disponível. Recarregue pra aplicar.');
              window.dispatchEvent(new CustomEvent('sw-update-ready', { detail: { reg } }));
            }
          });
        });
      })
      .catch((err) => {
        console.warn('[PWA] Falha ao registrar service worker:', err);
      });
  });
}

/** Força o SW novo (em waiting) a assumir o controle imediatamente. */
export function aplicarAtualizacaoSW(reg: ServiceWorkerRegistration): void {
  if (reg.waiting) {
    reg.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
}

/** Desregistra o SW (útil pra troubleshooting). */
export function unregisterSW(): void {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((reg) => reg.unregister())
    .catch(() => { /* ignora */ });
}
